window.DeviceBookingProgress = {

    currentStep: 1,

        init() {

        this.steps = Array.from(
            document.querySelectorAll(
                ".device-destruction-step"
            )
        );

        this.progress = Array.from(
            document.querySelectorAll(
                "[data-progress-step]"
            )
        );

        if (!this.steps.length) return;

        this.currentStep = 1;

        this.bind();

        this.showStep(this.currentStep);

    },
    
    bind() {

        document.addEventListener(
            "click",
            (event) => {

                const next = event.target.closest(
                    "[data-booking-next]"
                );

                if (next) {

                    event.preventDefault();

                    this.next();

                    return;

                }

                const back = event.target.closest(
                    "[data-booking-back]"
                );

                if (back) {

                    event.preventDefault();

                    this.previous();

                }

            }
        );

    },

    next() {

        /*
        |--------------------------------------------------------------------------
        | Step 3
        |--------------------------------------------------------------------------
        */

       

        if (this.currentStep < this.steps.length) {

            this.showStep(
                this.currentStep + 1
            );

        }

    },

    previous() {

        if (
            this.currentStep > 1
        ) {

            this.showStep(
                this.currentStep - 1
            );

        }

    },

    showStep(step) {

        this.currentStep = step;

        this.steps.forEach(item => {

            const itemStep = Number(
                item.dataset.bookingStep
            );

            item.hidden =
                itemStep !== step;

        });

        this.progress.forEach(item => {

            const progressStep = Number(
                item.dataset.progressStep
            );

            item.classList.toggle(

                "is-active",

                progressStep === step

            );

        });

        window.scrollTo({

            top: 0,

            behavior: "smooth"

        });

    }

};

document.addEventListener(

    "DOMContentLoaded",

    () => {

        window.DeviceBookingProgress.init();

    }

);